import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/api';
import './ProductCard.css';

const StarRating = ({ rating }) => {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map(s => (
        <span key={s} className={s <= Math.round(rating) ? 'star star-filled' : 'star star-empty'}>★</span>
      ))}
    </div>
  );
};

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const image = product.images?.[0]?.url;
  const price = product.discountPrice || product.price;
  const hasDiscount = product.discountPrice && product.discountPrice < product.price;

  const careLevelColor = {
    beginner: 'badge-green',
    intermediate: 'badge-earth',
    expert: 'badge-sale',
  };

  return (
    <div className="product-card card">
      <Link to={`/product/${product.slug || product._id}`} className="product-image-wrap">
        {image ? (
          <img src={image} alt={product.name} className="product-image" loading="lazy" />
        ) : (
          <div className="product-image-placeholder">🌱</div>
        )}
        {hasDiscount && (
          <span className="discount-badge">-{product.discountPercent}%</span>
        )}
        {product.stock === 0 && (
          <span className="out-of-stock-overlay">Out of Stock</span>
        )}
        {product.featured && (
          <span className="featured-badge">★ Featured</span>
        )}
      </Link>

      <div className="product-info">
        {product.careLevel && (
          <span className={`badge ${careLevelColor[product.careLevel]} mb-6`}>
            {product.careLevel}
          </span>
        )}
        <Link to={`/product/${product.slug || product._id}`}>
          <h3 className="product-name">{product.name}</h3>
        </Link>
        <p className="product-short-desc">{product.shortDescription || product.description?.slice(0, 80) + '...'}</p>

        <div className="product-tags">
          {product.petFriendly && <span className="tag">🐾 Pet Safe</span>}
          {product.airPurifying && <span className="tag">💨 Air Purifying</span>}
        </div>

        {product.numReviews > 0 && (
          <div className="product-rating">
            <StarRating rating={product.rating} />
            <span className="review-count">({product.numReviews})</span>
          </div>
        )}

        <div className="product-footer">
          <div className="product-price">
            <span className="price-current">{formatPrice(price)}</span>
            {hasDiscount && (
              <span className="price-original">{formatPrice(product.price)}</span>
            )}
          </div>

          <button
            className="add-to-cart-btn"
            onClick={() => addToCart(product)}
            disabled={product.stock === 0}
            aria-label={`Add ${product.name} to cart`}
          >
            {product.stock === 0 ? '✕' : '+'}
          </button>
        </div>
      </div>
    </div>
  );
}
